// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2XfdQ","tab":"Tabs_tab__1oNdy","tabActive":"Tabs_tabActive__1viN1"};